/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum PaymentStatusHistoryEntryTrigger {
  stripe_webhook = 'stripe_webhook',
  user_action = 'user_action',
  dispute_resolution = 'dispute_resolution',
  settlement_scheduler = 'settlement_scheduler',
  payout_scheduler = 'payout_scheduler',
  stale_payment_cleanup = 'stale_payment_cleanup',
  overlapping_booking_cleanup = 'overlapping_booking_cleanup',
  new_booking_same_activity = 'new_booking_same_activity',
  cancellation = 'cancellation',
  activity_deletion = 'activity_deletion',
  slot_cancellation = 'slot_cancellation',
  payment_started = 'payment_started'
}
